export default function Card({
    children,
    className = '',
    padding = 'px-4 py-2',
    ...rest
}) {
    return (
        <div
            className={` ${className} bg-white dark:bg-dark rounded-xl ${padding}`}
            {...rest}>
            {children}
        </div>
    )
}
